import Comment from "./core/Comment";


if (document.getElementById('commentary')) {
    new Comment(false);
}





// WEBPACK FOOTER //
// ./resources/js/connect-comment.js